import { ErrorBoundary } from 'react-error-boundary'
import { QueryClient, QueryClientProvider } from 'react-query'
import SomethingWentWrong from '@/components/Common/SomethingWentWrong'
const FullScreenCandlesChart = ({ children }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  })
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary FallbackComponent={SomethingWentWrong}>
        {children}
      </ErrorBoundary>
    </QueryClientProvider>
  )
}

export default FullScreenCandlesChart
